import { createAuthClient } from "better-auth/react";
import { twoFactorClient } from "better-auth/client/plugins";

// better-auth requires an absolute URL. In dev the Vite proxy tunnels
// /api → localhost:8787; in prod the API is served same-origin. Either way
// the client lives in the browser, so window.location.origin is the base.
// The twoFactorClient plugin extends session.user with twoFactorEnabled so
// the _authed MFA gate can read it without casts.
export const authClient = createAuthClient({
  baseURL: `${window.location.origin}/api/v1/auth`,
  plugins: [twoFactorClient()],
});

export const { signIn, signOut, useSession } = authClient;
